import type { DropdownOption } from 'components/DropdownListWithOptions';
import DropdownListWithOptions from 'components/DropdownListWithOptions';
import type { Props as PopoverProps } from 'components/popovers/Popover';
import Popover from 'components/popovers/Popover';
import ProjectSearch from 'components/projects/ProjectSearch';
import React, { Component } from 'react';
import { ProjectSuggestions } from 'routes/supercalendar/components/calendar/hour-editor/ProjectSuggestions';
import type { SuggestedEntryProject } from 'types/timeline';
import type { Merge } from 'types/utility';
import styles from './PopoverProjectPickerWithOptions.module.scss';

interface OwnProps {
  isInitallyOpen?: boolean;
  isProjectSearchOpen?: boolean;
  className?: string;
  closeOnClick: boolean;
  label: string;
  labelEmpty: string;
  value: number | null;
  onOpen: () => void;
  onClose: () => void;
  onChange: (projectId: number | null) => void;
  predictedProjects: Array<SuggestedEntryProject>;
  /** List of options that will be displayed */
  options?: Array<DropdownOption>;
  /** This will be called when an option is clicked */
  onOptionClick?: (option: DropdownOption, event: React.SyntheticEvent) => void;
  showProjects: boolean;
}

type Props = Merge<PopoverProps, OwnProps>;

interface State {
  isOpen: boolean;
}

export class PopoverProjectPickerWithOptions extends Component<Props, State> {
  static defaultProps = {
    value: null,
    label: 'I was working on project...',
    labelEmpty: 'What project does this relate to?',
    closeOnClick: false,
    predictedProjects: [],
    onOpen: () => {},
    onClose: () => {},
    showProjects: true,
  };

  state = {
    isOpen: this.props.isInitallyOpen || false,
  };

  // Open state must be handled here, to avoid triggering functions in <Popover>
  // via refs when <ProjectSearch> makes a selection, etc.
  handleTogglePopover = () => {
    const setToOpen = !this.state.isOpen;
    this.setState({ isOpen: setToOpen });

    if (setToOpen) {
      this.props.onOpen();
    } else {
      this.props.onClose();
    }
  };

  handleSelectProject = (projectId: number | null) => {
    this.handleTogglePopover();
    this.props.onChange(projectId);
  };

  render() {
    const {
      className,
      target,
      label,
      labelEmpty,
      value,
      isProjectSearchOpen,
      predictedProjects,
      options,
      onOptionClick,
      showProjects,
      ...rest
    } = this.props;

    const isEmpty = !value && !predictedProjects.length;
    const showOptions = !!options;

    const popoverProps = {
      ...rest,
      isOpen: this.state.isOpen,
      onOpen: this.handleTogglePopover,
      onClose: this.handleTogglePopover,
    };

    return (
      <Popover {...popoverProps} className={className} target={target}>
        <div className={styles.container}>
          {showProjects && (
            <React.Fragment>
              <label>{!isEmpty ? label : labelEmpty}</label>
              <ProjectSuggestions
                selectedProjectId={value}
                onChange={this.handleSelectProject}
                suggestions={predictedProjects}
              />
              {/* Todo: Smaller input size */}
              <ProjectSearch
                autoFocus={isProjectSearchOpen}
                className={styles.searchClass}
                onChange={this.handleSelectProject}
              />
            </React.Fragment>
          )}
          {showOptions && (
            <DropdownListWithOptions
              className={showProjects ? styles.optionsList : undefined}
              padding={0}
              options={options}
              onClick={onOptionClick}
            />
          )}
        </div>
      </Popover>
    );
  }
}
